import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal, Form, Input, Button, message, ColorPicker } from 'antd';
import { AppDispatch } from '../../../redux/store/store';
import { createSucursal } from '../../../redux/actions/sucursales/sucursales';
import EmpresasSelect from '../../select/EmpresasSelect';

interface CrearSucursalModalProps {
  visible: boolean;
  onClose: (refresh?: boolean) => void;
}

const CrearSucursalModal: React.FC<CrearSucursalModalProps> = ({
  visible,
  onClose
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [selectedEmpresa, setSelectedEmpresa] = useState<any>(null);

  const handleEmpresaChange = (value: string, empresa: any) => {
    setSelectedEmpresa(empresa);
    form.setFieldsValue({ empresaId: value });
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      if (values.empresaId) {
        values.empresaId = Number(values.empresaId);
      }

      if (values.color && typeof values.color === 'object' && values.color.toHexString) {
        values.color = values.color.toHexString(); 
      }

      setLoading(true);

      await dispatch(createSucursal(values));

      message.success('Sucursal creada exitosamente');
      form.resetFields();
      onClose(true);
    } catch (error) {
      console.error('Error al crear la sucursal:', error);
      message.error('Error al crear la sucursal');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Crear Nueva Sucursal"
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Crear Sucursal
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_crear_sucursal"
        initialValues={{ link_maps: '' }}
      >
        <Form.Item
          name="empresaId"
          label="Empresa"
          rules={[
            {
              required: true,
              message: 'Por favor seleccione una empresa',
            },
          ]}
        >
          <EmpresasSelect
            onChange={handleEmpresaChange}
            placeholder="Seleccione una empresa"
          />
        </Form.Item>

        <Form.Item
          name="nombre"
          label="Nombre"
          rules={[
            {
              required: true,
              message: 'Por favor ingrese el nombre de la sucursal',
            },
          ]}
        >
          <Input placeholder="Ej. Sucursal Central" />
        </Form.Item>

        <Form.Item
          name="direccion"
          label="Dirección"
          rules={[
            {
              required: true,
              message: 'Por favor ingrese la dirección de la sucursal',
            },
          ]}
        >
          <Input placeholder="Ej. Av. Principal 123, Lima" />
        </Form.Item>

        <Form.Item
          name="link_maps"
          label="Link de Google Maps"
          rules={[
            {
              type: 'url',
              message: 'Por favor ingrese una URL válida',
            },
          ]}
        >
          <Input placeholder="https://maps.google.com/?q=..." />
        </Form.Item>

        <Form.Item
          name="color"
          label="Color"
          rules={[{ required: true, message: 'Por favor seleccione un color' }]}
        >
          <ColorPicker showText />
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default CrearSucursalModal;